// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { updateCart } from "@insite/client-framework/Services/CartService";
import {
    chain,
    DispatchCompleteLoadCart,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";

export const XngPopulateApiParameter: any = (props: any) => {
    const ootbExpand = (props.apiParameter.expand || []).filter((e: string) => e !== "carriers");
    props.apiParameter.expand = [...ootbExpand, "cartLines", "restrictions", "paymentOptions"];
};

export const PreventCacheForRockwellCart = (props: any) => {
    const location = getLocation(props.getState());
    const rockwellSuccess = parseQueryString<{ rockwellSuccess?: string }>(location.search).rockwellSuccess;
    if (rockwellSuccess) {
        (props.apiParameter as any).epoch = new Date().getTime();
    }
};

export const UpdateCart = (props: any) => {
    const location = getLocation(props.getState());
    const rockwellSuccess = parseQueryString<{ rockwellSuccess?: string }>(location.search).rockwellSuccess;
    if (rockwellSuccess) {
        updateCart({ cart: props.apiResult.cart });
    }
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
addToChainAfter(chain, XngPopulateApiParameter, PreventCacheForRockwellCart);
addToChainAfter(chain, DispatchCompleteLoadCart, UpdateCart);
